var _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCopylinkButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "svg-copylink",
  viewBox: "0 0 48 48"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#32A0A6"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M28.725 13.5c1.54 0 2.998.595 4.083 1.692a5.7 5.7 0 0 1 1.692 4.083c0 1.54-.595 2.987-1.68 4.072l-3.033 3.033a2 2 0 0 1-.178.146 2 2 0 0 0-.126.099q.07-.473.07-.945c0-.712-.105-1.4-.303-2.065l1.913-1.913a3.42 3.42 0 0 0 1.004-2.427c0-.922-.362-1.785-1.004-2.438a3.46 3.46 0 0 0-2.438-1.004c-.922 0-1.785.362-2.427 1.015l-3.045 3.045a3.42 3.42 0 0 0-1.003 2.427c0 .91.35 1.773 1.003 2.427.304.291.642.525 1.015.688.012.082.024.175.024.257 0 .525-.21 1.026-.584 1.4l-.443.443a5.727 5.727 0 0 1-3.348-5.227c0-1.54.595-2.986 1.691-4.083l3.034-3.033a5.7 5.7 0 0 1 4.083-1.692m-4.433 7.408.443-.443c.607.28 1.167.653 1.657 1.143a5.73 5.73 0 0 1 1.691 4.084c0 1.54-.606 2.998-1.691 4.083l-3.034 3.033a5.7 5.7 0 0 1-4.083 1.692 5.7 5.7 0 0 1-4.083-1.692 5.73 5.73 0 0 1-1.692-4.083c0-1.54.595-2.987 1.692-4.083l3.033-3.034c.057-.057.123-.105.184-.15q.06-.043.108-.083-.07.473-.07.945c0 .712.105 1.4.303 2.065l-1.913 1.913a3.42 3.42 0 0 0-1.004 2.427c0 .922.362 1.785 1.004 2.438a3.46 3.46 0 0 0 2.438 1.004c.922 0 1.785-.362 2.427-1.015l3.045-3.045a3.42 3.42 0 0 0 1.003-2.427c0-.91-.35-1.773-1.003-2.427a3.5 3.5 0 0 0-1.015-.688 2 2 0 0 1-.024-.257c0-.525.21-1.026.584-1.4",
  clipRule: "evenodd",
  style: {
    fill: "#fafdff"
  }
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  width: 44,
  height: 44,
  x: 2,
  y: 4,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.00185764 0 0 0 0 0.422869 0 0 0 0 0.445833 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));
export default SvgCopylinkButton;